import { grey } from "@mui/material/colors";

const styles = {
  card: {
    border: "1px solid",
    borderColor: grey[200],
    borderRadius: 3,
  },
  detailsContainer: {
    px: 3,
    display: "flex",
    flexDirection: "column",
    gap: 2,
    pb: 3,
  },
  emailBodyStyles: (isLong: boolean, isExpanded: boolean) => ({
    fontSize: 14,
    lineHeight: 1.7,
    color: grey[800],
    "& p": { margin: "0 0 12px 0" },
    "& a": { color: "#2563eb" },
    p: 2,
    borderRadius: 2,
    backgroundColor: grey[50],
    border: `1px solid ${grey[100]}`,
    overflow: "hidden",
    maxHeight: isLong && !isExpanded ? 120 : "none",
  }),
  template: (i: number, activeIndex: number) => ({
    width: 10,
    height: 10,
    borderRadius: "50%",
    cursor: "pointer",
    backgroundColor: i === activeIndex ? "#548a79" : grey[300],
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: i === activeIndex ? "#548a79" : grey[400],
    },
  }),
  previewTemplateContainer: {
    display: "flex",
    justifyContent: "center",
    gap: 1,
    mt: 3,
  },
  viewMoreOverlay: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
    height: 48,
    background: `linear-gradient(transparent, ${grey[50]})`,
    borderRadius: "0 0 6px 6px",
  },
  subject: {
    fontSize: 12,
    fontWeight: 600,
    color: grey[500],
    mb: 0.5,
  },
  contentType: {
    fontSize: 12,
    fontWeight: 600,
    color: grey[500],
    mb: 0.5,
    textTransform: "uppercase",
  },
  timezone: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    bgcolor: grey[100],
    border: "1px solid",
    borderColor: grey[300],
    borderRadius: 1.5,
    px: 1,
    py: 0.25,
    fontSize: 12,
    color: grey[900],
    fontWeight: 500,
  },
  emailPerDay: {
    display: "inline-flex",
    alignItems: "center",
    gap: 0.5,
    bgcolor: "purple.light",
    border: "1px solid",
    borderColor: "purple.main",
    borderRadius: 1.5,
    px: 1,
    py: 0.25,
    fontSize: 12,
    color: "purple.dark",
    fontWeight: 600,
  },
};

export default styles;
